import { z } from 'zod';

import {
  permissionScopeValues,
  type ListPermissionsResponse,
  type PermissionDto,
  type PermissionScope,
} from './permissions.dto.js';

export const PermissionSchema: z.ZodType<PermissionDto> = z.object({
  key: z.string().trim().min(1),
  description: z.string().trim().min(1),
  scope: z.enum(permissionScopeValues),
});

export const ListPermissionsResponseSchema: z.ZodType<ListPermissionsResponse> = z.object({
  items: z.array(PermissionSchema),
});

export const PermissionScopeSchema: z.ZodType<PermissionScope> = z.enum(permissionScopeValues);
